import axios from 'axios'
import { config } from '../shared/app.config'

const RESOURCE_NAME = '/paymenttypes'

export default {
  list(page, per_page, search = '', orderBy = '') {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/list`, {
      page,
      per_page,
      search,
      orderBy,
    })
  },
  edit(id, payment) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/${id}`, payment)
  },
  create(payment) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}`, payment)
  },
  getPayment(id) {
    return axios.get(`${config.webApiBase + RESOURCE_NAME}/${id}`)
  },
  delete(id) {
    return axios.delete(`${config.webApiBase + RESOURCE_NAME}/${id}`)
  },
}
